export const environment = {
  apiGatewayConfig: {
    apiGatewayUrl: 'https://api-gateway-sqa.drcedirect.com/',
    apiGatewayCloudUrl: 'https://api-gateway-cloud-sqa.drcedirect.com',
    client: 'all',
    deployment: 'sqa',
    version: 'v0',
    enableCache: true,
    dynatraceConfig: {
      scriptUrl: 'https://js-cdn.dynatrace.com/jstag/17b628055ae/bf63792rhe/8e09d4c4636cdb1f_complete.js'
    }
  },
  production: true,
  okta: {
    clientConfig: {
      issuer: 'https://auth-sqa.drcedirect.com/oauth2/default',
      clientId: 'eca-portal',
      redirectUri: 'https://cdn-app-sqa.drcedirect.com',
      pkce: true,
      tokenManager: {
        secure: true,
        storage: 'sessionStorage'
      }
    },
    samlRedirectUrl: 'https://auth-sqa.drcedirect.com/app/datarecognitioncorpsqa_ecainsightportal_1/exkipm7nEejkew7ga1d5/sso/saml'
  },
  islandBrowserUrl: 'https://auth-sqa.drcedirect.com/app/datarecognitioncorp-sqa_pasislandbrowser_1/exkkftn5u9adqyApo1d7/sso/saml',
  userManagementUrl: 'https://sqa.uum-le.drcedirect.com',
  serviceNowUrl: 'https://datarecognitioncorpdev.service-now.com/customerserviceportal2?id=csp2_connect_chat',
  genesys: {
    deploymentId: '37a742bf-b5a0-47af-b552-d211ab3d8a44',
    environment: 'usw2',
    orgGuid: '4e8196cb-bd36-4309-9008-eea81adb60b3',
    script: 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js'
  },
  confluenceUrl: 'https://eps-sqa.awcl.drcedirect-le.com/api/v1/docs',
  useNewLoginPage: true
};
